import { render, staticRenderFns } from "./TurmaRow.vue?vue&type=template&id=40bb8a70&scoped=true&"
import script from "./TurmaRow.vue?vue&type=script&lang=js&"
export * from "./TurmaRow.vue?vue&type=script&lang=js&"
import style0 from "./TurmaRow.vue?vue&type=style&index=0&id=40bb8a70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb8a70",
  null
  
)

export default component.exports